export const MTK_DECIMALS = 6;

export const FEES = {
  entry: {
    max: 500n,
    min: 1n,
  },
  exit: {
    max: 500n,
    min: 1n,
  },
  batcher: {
    max: 4_000_000n,
    min: 1n,
  },
  platform: {
    max: 100n,
    min: 1n,
  },
} as const;
